export function isBotOrLighthouse(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    const botPatterns = [
        /bot\b/,
        /crawl(er)?\b/,
        /spider\b/,
        /slurp\b/,
        /bingpreview\b/,
        /yandex\b/,
        /duckduckbot\b/,
        /baiduspider\b/,
        /sogou\b/,
        /exabot\b/,
        /facebot\b/,
        /ia_archiver\b/,
        /lighthouse\b/,
    ];
    // Check if the user agent matches any bot patterns
    const isBot = botPatterns.some((pattern) => pattern.test(ua));

    // Check if the query string contains simulateBot=true
    const urlParams = new URLSearchParams(window.location.search);
    const simulateBot = urlParams.get("simulateBot") === "true";

    return isBot || simulateBot;
}